import React, { useEffect, useState } from "react";
import axios from "axios";
import "./rolling.css";

const API_BASE = "https://peralassery.cubixsystems.com/myapp/api/uploads";

function Rolling() {
  const [uploads, setUploads] = useState([]);

  useEffect(() => {
    fetchUploads();
  }, []);

  const fetchUploads = async () => {
    const res = await axios.get(`${API_BASE}/get_notice.php`);
    setUploads(res.data || []);
  };

  return (
    <div className="rolling-container" style={{height:'80px'}}>
      {/* <h4 className="rolling-title">Latest Updates</h4> */}

      <div className="rolling-wrapper">
        <div className="rolling-content">
         
            <div
              
              className="rolling-item" 
             
            >
              <span className="icon-">👉</span>
              <span className="text" style={{fontWeight:'600',fontSize:'18pt'}}>Latest Updates</span>
            </div>
         
        </div>
      </div>
    </div>
  );
}

export default Rolling;
